<style lang="less" scoped>
    .bill-company-selector{
        display: inline-block;
        width: 100%
    }
    .ivu-poptip {
      width: 100%;
      display: block;
      /deep/.ivu-poptip-rel {
        display: block;
      }
    }
    .common-company{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
<template>
    <div class="bill-company-selector">
        <Poptip trigger="focus" title="常用公司" :placement="placement">
            <Input autocomplete="new-password" :placeholder="placeholder" :value="value" :disabled="disabled" @on-change="inputChange" />
            <div slot="content">
              <div class="common-company" v-for="(company, i) in common_commpanies" :key="i">
                  <Button size="small" @click="setCity(company)">
                      {{company.name}}
                  </Button>
              </div>
            </div>
            <div class="color-grey">其他公司请在输入框直接输入</div>
        </Poptip>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            value: {
                type: String
            },
            size: {
                type: String,
                'default': ''
            },
            placeholder: {
                type: String,
                'default': ''
            },
            placement: {
                type: String,
                'default': 'bottom-start'
            },
            disabled: {
                type: Boolean,
                'default': false
            }
        },
        data(){
            return {
                common_commpanies: [
                    {
                        name: "FIVERR INTERNATIONAL LTD",
                    },
                    {
                        name: "THE VOICE REALM LLC",
                    },
                ]
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            setCity(city){
                this.$emit('input', city.name);
            },
            inputChange(event){
                this.$emit('input', event.target.value);
            }
        }
    }
</script>
